import { useState } from "react";
import { Button } from "../../../components/button/button";
import { LightningIcon, ScaleIcon } from "../../../assets/icons";
import { useDispatch } from "react-redux";
import { setUserProgress } from "../../../features/userReducer";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { usePopup } from "../../../components/popup/popup";
import { Range } from "../../../components/range/range";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { Text } from "../../../components/text/text";

import CheckListAPI from "../../../api/CheckListAPI";
import classNames from "classnames";

import styles from "./checkList.module.css"
import { Image } from "../../../components/image/image";

const priorities = ["Низкий", "Средний", "Высокий"];

export const CheckListItem = ({ data, setData, tabId }) => {
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const onComplete = async (done = data.countTotal) => {
        setLoading(true);

        try {
            if (data.countDone === 0 && done > 0) {
                const res = await CheckListAPI.completeStep(data.id, data.taskType, done, data.countTotal);
                setData(prev => prev.map(item => item.id === data.id ? { ...item, countDone: res.countDone } : item));

                if (!data.rewardReceived && data.rewardExp > 0) {
                    const receiveRes = await CheckListAPI.receiveTaskExp(data.id, data.rewardExp, data.taskType);
                    setData(prev => prev.map(item => item.id === data.id ? { ...item, rewardReceived: receiveRes.rewardReceived } : item));
                    dispatch(setUserProgress({ newExp: receiveRes.levelInfo.newExp, newLevel: receiveRes.levelInfo.newLevel }));
                }
            }
        } catch (err) {
            console.error(err);
        }

        setLoading(false);
    }

    const onCancel = async () => {
        setLoading(true);

        try {
            const res = await CheckListAPI.completeStep(data.id, data.taskType, 0, data.countTotal);
            setData(prev => prev.map(item => item.id === data.id ? { ...item, countDone: res.countDone } : item));

            if (data.rewardReceived) {
                const receiveRes = await CheckListAPI.cancelCompletion(data.id, data.taskType);
                setData(prev => prev.map(item => item.id === data.id ? { ...item, rewardReceived: receiveRes.rewardReceived } : item));
                dispatch(setUserProgress({ newExp: receiveRes.levelInfo.newExp, newLevel: receiveRes.levelInfo.newLevel }));
            }
        } catch (err) {
            console.error(err);
        }

        setLoading(false);
    }

    const openPage = useOpenPage();

    const [steps, setSteps] = useState(1);
    const [StepsPopup, openPopup, closePopup] = usePopup();

    const [CancelPopup, openCancelPopup] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите отменить выполнение задачи?",
        onCancel
    )

    return (
        <>
            <div className={styles.check_list_item} onClick={openPage(`${data.id}?initialTab=${tabId}`)}>
                <div className={styles.check_list_item_header}>
                    <div className={styles.extra_header}>
                        <Text as="div" variant="body" className={styles.check_list_item_name} >{data.taskText}</Text>
                        <div className={classNames(styles.check_list_item_priority, {
                            [styles.low]: data.priority <= 0,
                            [styles.medium]: data.priority === 1,
                            [styles.high]: data.priority >= 2,
                        })}>
                            <LightningIcon />
                            {priorities[Math.max(0, Math.min(2, data.priority))]}
                        </div>
                        { data.note && <Text as="div" variant="caption" clamp={2}><b>Комментарий:</b> {data.note}</Text> }
                        {
                            data.photos && data.photos.length > 0 &&
                            <div className={styles.photos_container}>
                                {
                                    data.photos.map((photo) => (
                                        <Image
                                            radius="6px"
                                            key={photo}
                                            src={photo}
                                            alt=""
                                            objectFit="cover"
                                        />
                                    ))
                                }
                            </div>
                        }
                    </div>
                    <ScaleIcon />
                </div>

                <Button
                    type={data.countDone === 0 ? "destructive" : "done"}
                    disabled={loading}
                    text={data.countDone === 0 ? "Не выполнено" : (data.countTotal > 1 ? `Выполнено ${data.countDone}/${data.countTotal}` : "Выполнено")}
                    className={styles.add_xp_button}
                    onClick={e => {
                        e.stopPropagation();
                        if (data.countDone > 0) {
                            openCancelPopup();
                        } else {
                            if (data.countTotal > 1) {
                                openPopup();
                            } else {
                                onComplete();
                            }
                        }
                    }}
                />

                <StepsPopup>
                    <Text as="div" variant="h3" className={styles.steps_title} >
                        Введите количество выполненных шагов
                    </Text>

                    <Range
                        min={1}
                        max={data.countTotal}
                        value={steps}
                        onChange={setSteps}
                        withValue
                    />

                    <div className={styles.buttons}>
                        <Button
                            text="Отмена"
                            onClick={() => {
                                setSteps(1);
                                closePopup();
                            }}
                            type="hint"
                        />
                        <Button
                            text="Сохранить"
                            onClick={() => {
                                onComplete(steps);
                                setSteps(1);
                                closePopup();
                            }}
                        />
                    </div>
                </StepsPopup>
            </div>

            {CancelPopup}
        </>
    );
}